import React from 'react'
import { Divider, Grid, Typography } from '@mui/material'
import styled from 'styled-components/macro'

import UserIcon from '@mui/icons-material/AccountCircleOutlined'
import NumOfQuestionsIcon from '@mui/icons-material/HelpOutlineOutlined'
import TimeLimitIcon from '@mui/icons-material/AccessTime'
import StartIcon from '@mui/icons-material/KeyboardArrowRight'

import { PublicCertificate } from 'src/types/graphql'
import { ReadOnlyRichtext } from '../../Utils/Richtext/ReadOnlyRichtext'
import { Icon } from '../Icon'
import AsyncButton from 'src/components/Utils/AsyncButton/AsyncButton'
import { Duration } from 'luxon'

const DataGridItem = styled(Grid)`
    display: flex;
    align-items: center;
`

type CertificateStartScreenProps = {
    certificate: PublicCertificate
    onStart: () => Promise<void>
}

export function CertificateStartScreen({ certificate, onStart }: CertificateStartScreenProps) {
    return (
        <Grid container spacing={2} alignItems="center">
            <Grid item xs={12}>
                <Typography variant="h4" fontWeight="bold">
                    {certificate.name}
                </Typography>
            </Grid>
            <DataGridItem item xs={5}>
                <Icon tooltip="Teilnehmer">
                    <UserIcon />
                </Icon>
                <b>{certificate.user.name}</b>&nbsp;({certificate.user.email})
            </DataGridItem>
            <DataGridItem item xs={2}>
                <Icon tooltip="Anzahl der Fragen, die beantwortet werden müssen">
                    <NumOfQuestionsIcon />
                </Icon>
                <b>{certificate.numOfQuestions} Fragen</b>
            </DataGridItem>
            <DataGridItem item xs={3}>
                <Icon tooltip="Gesetztes Zeitlimit zur Beantwortung der Fragen">
                    <TimeLimitIcon />
                </Icon>
                <b>
                    {certificate.timeLimitMs === 0 ? (
                        <>Kein Zeitlimit</>
                    ) : (
                        <>{Duration.fromMillis(certificate.timeLimitMs).toFormat('hh:mm')} Stunde(n)</>
                    )}
                </b>
            </DataGridItem>
            <Grid item xs={12}>
                <Divider />
            </Grid>
            <Grid item xs={12}>
                <ReadOnlyRichtext document={certificate.certificateConfiguration.description} />
            </Grid>
            <Grid item xs={12} mt={4}>
                <AsyncButton variant="contained" size="large" onClick={() => onStart()}>
                    <StartIcon />
                    Starte Zertifizierung
                </AsyncButton>
            </Grid>
        </Grid>
    )
}
